(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cna-category-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cna-category-products')) {
  customElements.define('cna-category-products',class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const buttons = this.querySelectorAll('[data-category-filter]');
      const items = this.querySelectorAll('[data-category-kind]');
      const status = this.querySelector('[data-category-count]');
      buttons.forEach(button => button.addEventListener('click',() => {
        let visible = 0;
        buttons.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
        items.forEach(item => { item.hidden = button.dataset.categoryFilter !== 'all' && item.dataset.categoryKind !== button.dataset.categoryFilter; if (!item.hidden) visible++; });
        if (status) status.textContent = status.dataset.countTemplate.replace('[count]',String(visible));
      },{signal:this.controller.signal}));
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cna-wholesale-inquiry"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cna-wholesale-form')) {
  customElements.define('cna-wholesale-form', class extends HTMLElement {
    connectedCallback() {
      const polish = () => {
        const form = this.querySelector('form[data-id="39682"]');
        if (!form || !form.querySelector('button.submit') || form.querySelectorAll('input').length < 8) return;
        const fields = { text:'given-name', 'text-2':'family-name', 'name-1':'organization', 'text-1':'street-address', email:'email', 'phone-1':'tel', 'text-4':'url' };
        Object.entries(fields).forEach(([name,value]) => {
          const input = form.querySelector('[name="'+name+'"]');
          if (input) input.autocomplete = value;
        });
        const email = form.querySelector('[name="email"]');
        const phone = form.querySelector('[name="phone-1"]');
        if(email) email.inputMode = 'email';
        if(phone) phone.inputMode = 'tel';
        const button = form.querySelector('button.submit');
        if (button) {
          Array.from(button.childNodes).filter(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim() && node.textContent.trim() !== this.dataset.submitLabel).forEach(node => node.textContent = this.dataset.submitLabel);
          button.setAttribute('aria-label',this.dataset.submitLabel);
          button.dataset.submitText = button.innerHTML;
        }
      };
      this.observer = new MutationObserver(polish);
      this.observer.observe(this,{childList:true,subtree:true});
      polish();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cna-wholesale-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cna-wholesale-showcase')) {
  customElements.define('cna-wholesale-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animate !== 'true' || window.Shopify?.designMode || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const target = entry.target;
          target.classList.remove('wh-awaiting');
          target.classList.add('wh-revealed');
          target.dataset.whSeen = 'true';
          this.observer.unobserve(target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
      this.querySelectorAll('[data-wh-reveal]').forEach(target => {
        if (target.dataset.whSeen === 'true') return;
        if (target.getBoundingClientRect().top < innerHeight - 30) {
          target.classList.remove('wh-awaiting');
          if(target.classList.contains('wh-banner--first')) target.classList.add('wh-revealed');
          target.dataset.whSeen = 'true';
          return;
        }
        target.classList.add('wh-awaiting');
        this.observer.observe(target);
      });
      this.focusHandler = event => {
        const target = event.target.closest('.wh-awaiting');
        if (!target) return;
        target.classList.remove('wh-awaiting');
        target.dataset.whSeen = 'true';
        this.observer.unobserve(target);
      };
      this.addEventListener('focusin', this.focusHandler);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.focusHandler) this.removeEventListener('focusin',this.focusHandler);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowing-hotspot-banner"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('cna-hotspot-media')) {
    customElements.define('cna-hotspot-media', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.img = this.querySelector('img');
        this.canvas = this.querySelector('canvas');
        this.button = this.querySelector('button');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.img.addEventListener('load', () => this.sync(), options);
        this.button.addEventListener('click', () => this.setPaused(!this.hasAttribute('data-paused')), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        if (this.img.complete) this.sync();
      }
      disconnectedCallback() { this.controller?.abort(); }
      sync() {
        const animated = /\.gif(?:[?#]|$)/i.test(this.img.currentSrc || this.img.src);
        this.button.hidden = !animated;
        this.setPaused(animated && this.motion.matches);
      }
      setPaused(paused) {
        if (paused && this.img.naturalWidth) {
          const scale = Math.min(1, 1600 / this.img.naturalWidth);
          this.canvas.width = Math.round(this.img.naturalWidth * scale);
          this.canvas.height = Math.round(this.img.naturalHeight * scale);
          this.canvas.getContext('2d').drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
          this.canvas.style.objectPosition = getComputedStyle(this.img).objectPosition;
        } else { paused = false; }
        this.toggleAttribute('data-paused', paused);
        this.canvas.hidden = !paused;
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.textContent = paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      }
    });
  }


  if (!customElements.get('cna-interactive-banner')) {
    customElements.define('cna-interactive-banner',class extends HTMLElement {
      connectedCallback() {
        this.controller=new AbortController();
        this.resizeObserver=new ResizeObserver(()=>this.layoutLabels());
        this.resizeObserver.observe(this);
        const options={signal:this.controller.signal};
        document.addEventListener('shopify:block:select',event=>this.markSelected(event,true),options);
        document.addEventListener('shopify:block:deselect',event=>this.markSelected(event,false),options);
        if(this.hasAttribute('data-breathe')) {
          this.inView=false;
          this.visibilityObserver=new IntersectionObserver(entries=>{
            this.inView=entries[0].isIntersecting;
            this.syncBreathing();
          });
          this.visibilityObserver.observe(this);
          document.addEventListener('visibilitychange',()=>this.syncBreathing(),options);
        }
        this.layoutLabels();
        document.fonts?.ready.then(()=>{if(this.isConnected)this.layoutLabels();});
      }
      disconnectedCallback() { this.resizeObserver?.disconnect();this.visibilityObserver?.disconnect();this.controller?.abort(); }
      syncBreathing() { this.classList.toggle('is-in-view',this.inView&&!document.hidden); }
      markSelected(event,selected) {
        for(const point of this.querySelectorAll('[data-hotspot-id]')) {
          if(point.dataset.hotspotId===event.detail?.blockId)point.classList.toggle('is-selected',selected);
        }
      }
      layoutLabels() {
        const stage=this.getBoundingClientRect();
        const mobile=matchMedia('(max-width:749px)').matches;
        const maxWidth=Number(this.dataset.labelWidth)||200;
        for(const point of this.querySelectorAll('[data-hotspot-id]')) {
          const link=point.querySelector('.cna-hotspot__link');
          const label=point.querySelector('.cna-hotspot__label');
          const box=link.getBoundingClientRect();
          const border=parseFloat(getComputedStyle(this).borderLeftWidth)||0;
          const available={left:box.left-stage.left-border-22,right:stage.right-box.right-border-22};
          const preferred=mobile&&point.dataset.mobileSide!=='same'?point.dataset.mobileSide:point.dataset.preferredSide;
          const opposite=preferred==='left'?'right':'left';
          label.style.maxWidth=maxWidth+'px';
          const desiredWidth=Math.min(maxWidth,label.getBoundingClientRect().width);
          const side=available[preferred]<desiredWidth&&available[opposite]>available[preferred]?opposite:preferred;
          point.dataset.side=side;
          label.style.maxWidth=Math.max(24,Math.min(maxWidth,available[side]))+'px';
        }
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cna-spotlight-media')) {
    customElements.define('cna-spotlight-media', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.img = this.querySelector('img');
        this.canvas = this.querySelector('canvas');
        this.button = this.querySelector('button');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.img.addEventListener('load', () => this.sync(), options);
        this.button.addEventListener('click', () => this.setPaused(!this.hasAttribute('data-paused')), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        if (this.img.complete) this.sync();
      }
      disconnectedCallback() { this.controller?.abort(); }
      sync() {
        const animated = /\.gif(?:[?#]|$)/i.test(this.img.currentSrc || this.img.src);
        this.button.hidden = !animated;
        this.setPaused(animated && this.motion.matches);
      }
      setPaused(paused) {
        if (paused && this.img.naturalWidth) {
          const scale = Math.min(1, 1600 / this.img.naturalWidth);
          this.canvas.width = Math.round(this.img.naturalWidth * scale);
          this.canvas.height = Math.round(this.img.naturalHeight * scale);
          this.canvas.getContext('2d').drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
          this.canvas.style.objectPosition = getComputedStyle(this.img).objectPosition;
        } else { paused = false; }
        this.toggleAttribute('data-paused', paused);
        this.canvas.hidden = !paused;
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.textContent = paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pair-spotlight"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('cna-pair-media')) {
    customElements.define('cna-pair-media', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.img = this.querySelector('img');
        this.canvas = this.querySelector('canvas');
        this.button = this.querySelector('button');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.img.addEventListener('load', () => this.sync(), options);
        this.button.addEventListener('click', () => this.setPaused(!this.hasAttribute('data-paused')), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        if (this.img.complete) this.sync();
      }
      disconnectedCallback() { this.controller?.abort(); }
      sync() {
        const animated = /\.gif(?:[?#]|$)/i.test(this.img.currentSrc || this.img.src);
        this.button.hidden = !animated;
        this.setPaused(animated && this.motion.matches);
      }
      setPaused(paused) {
        if (paused && this.img.naturalWidth) {
          const scale = Math.min(1, 1600 / this.img.naturalWidth);
          this.canvas.width = Math.round(this.img.naturalWidth * scale);
          this.canvas.height = Math.round(this.img.naturalHeight * scale);
          this.canvas.getContext('2d').drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
          this.canvas.style.objectPosition = getComputedStyle(this.img).objectPosition;
        } else { paused = false; }
        this.toggleAttribute('data-paused', paused);
        this.canvas.hidden = !paused;
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.textContent = paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-collage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cna-scroll-collage')) {
    customElements.define('cna-scroll-collage', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.cna-collage__track');
        this.cards = [...this.querySelectorAll('.cna-collage__card')];
        this.dots = [...this.querySelectorAll('.cna-collage__dot')];
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.playButton = this.querySelector('[data-play]');
        this.controls = this.querySelector('.cna-collage__controls');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.playing = this.dataset.autoplay === 'true' && !this.motion.matches && this.dataset.editor !== 'true';
        this.visible = false;
        this.hovered = false;
        this.index = 0;
        this.points = [0];
        this.media = [...this.querySelectorAll('.cna-collage__media')];
        this.previous.addEventListener('click', () => { this.setPlaying(false); this.go(this.index - 1); }, options);
        this.next.addEventListener('click', () => { this.setPlaying(false); this.go(this.index + 1); }, options);
        this.playButton.addEventListener('click', () => this.setPlaying(!this.playing), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => { this.setPlaying(false); this.go(index); }, options));
        this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update()); }, { ...options, passive: true });
        this.track.addEventListener('pointerdown', () => this.setPlaying(false), options);
        this.track.addEventListener('wheel', event => { if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || event.shiftKey) this.setPlaying(false); }, { ...options, passive: true });
        this.track.addEventListener('focusin', () => this.setPlaying(false), options);
        this.track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
          event.preventDefault();
          this.setPlaying(false);
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.points.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
          this.go(index);
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', event => { if (event.target !== this.playButton) this.setPlaying(false); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.setPlaying(false); }, options);
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
          if (!card) return;
          this.setPlaying(false);
          this.track.scrollTo({ left: this.cardPosition(card), behavior: 'instant' });
        }, options);
        this.media.forEach(media => {
          const img = media.querySelector('img');
          img.addEventListener('load', () => { this.syncMedia(); this.layout(); }, options);
        });
        this.resize = new ResizeObserver(() => this.layout());
        this.resize.observe(this.track);
        this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: .2 });
        this.intersection.observe(this);
        this.setAttribute('data-ready', '');
        this.layout();
        this.setPlaying(this.playing);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resize?.disconnect();
        this.intersection?.disconnect();
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
      }
      cardPosition(card) {
        const inset = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        return Math.max(0, Math.min(this.track.scrollWidth - this.track.clientWidth, card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft - inset));
      }
      layout() {
        this.points = [];
        this.cards.forEach(card => {
          const position = this.cardPosition(card);
          if (!this.points.length || Math.abs(position - this.points[this.points.length - 1]) > 2) this.points.push(position);
        });
        if (!this.points.length) this.points = [0];
        this.dots.forEach((dot, index) => { dot.hidden = index >= this.points.length; });
        const hasGif = this.media.some(media => /\.gif(?:[?#]|$)/i.test(media.querySelector('img').currentSrc || media.querySelector('img').src));
        this.controls.hidden = this.cards.length === 0 || (this.points.length < 2 && !hasGif);
        this.playButton.hidden = this.points.length < 2 && !hasGif;
        this.querySelector('.cna-collage__arrows').hidden = this.points.length < 2;
        this.querySelector('.cna-collage__dots').hidden = this.points.length < 2;
        this.update();
        this.schedule();
      }
      update() {
        const position = this.track.scrollLeft;
        this.index = this.points.reduce((nearest, point, index) => Math.abs(point - position) < Math.abs(this.points[nearest] - position) ? index : nearest, 0);
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index >= this.points.length - 1;
      }
      go(index) {
        const target = Math.max(0, Math.min(this.points.length - 1, index));
        this.track.scrollTo({ left: this.points[target], behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      setPlaying(playing) {
        this.playing = playing;
        this.toggleAttribute('data-playing', playing);
        this.playButton.setAttribute('aria-pressed', String(playing));
        this.playButton.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
        this.syncMedia();
        this.schedule();
      }
      syncMedia() {
        this.media.forEach(media => {
          const img = media.querySelector('img');
          const canvas = media.querySelector('canvas');
          const animated = /\.gif(?:[?#]|$)/i.test(img.currentSrc || img.src);
          const pause = animated && !this.playing && img.naturalWidth > 0;
          if (pause) {
            const scale = Math.min(1, 1600 / img.naturalWidth);
            canvas.width = Math.round(img.naturalWidth * scale);
            canvas.height = Math.round(img.naturalHeight * scale);
            canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.style.objectPosition = getComputedStyle(img).objectPosition;
          }
          media.toggleAttribute('data-paused', pause);
          canvas.hidden = !pause;
        });
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.playing || !this.visible || this.hovered || document.hidden || this.points.length < 2) return;
        this.timer = setTimeout(() => { this.go((this.index + 1) % this.points.length); this.schedule(); }, Number(this.dataset.interval) || 10000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
